import React from "react";
import "./DbMain.css";
import "bootstrap/dist/css/bootstrap.min.css";
import DB from "../../../Assets/Images/Technology/DB/Frame 1984078465.svg";
import bannerImg from "../../../Assets/Images/Technology/DB/OBJECTS.svg";
import arrowIcon from "../../../Assets/Icons/arrow-right-icon.svg";
import arrowIcon2 from "../../../Assets/Icons/arrow-right-icon-white.svg";
import example from "../../../Assets/Icons/Icon Wrapper.svg";

function DbMain() {
  return (
    <div className="db-main">
      <div className="db-content">
        <section className="db-start">
          <p>
            Modern systems do not normally use a single database. Different
            types of data behave differently, and cramming everything into one
            storage model typically causes problems in performance or
            maintenance later. At Quad Theory Ltd, we don't select database
            technologies based on popularity, but on access patterns, scale and
            long term access.
          </p>
        </section>
        {/* DB Image Section */}
        <div className="db-image">
          <img className="img-fluid" src={DB} alt="DB Tech Diagram" />
        </div>

        {/* SQLite*/}
        <div className="db-section">
          <h2>
            <span className="span-1">SQLite —</span>{" "}
            <span className="span-2">The Quiet Workhorse Inside The App</span>
          </h2>
          <p>
            SQLite is frequently invisible to users, yet it is extremely
            important in products that need to work reliably without relying on
            a network. We use it when speed, simplicity, and local access of
            data are more important than scale.
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> Stores data at the application
              level.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Works well for offline first mobile
              and desktop apps.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Makes small to mid sized products
              predictable.
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              A field service mobile app uses SQLite to allow technicians to
              access and update job information even in areas with poor
              connectivity.
            </p>
          </div>
        </div>
        {/* MySQL*/}
        <div className="db-section">
          <h2>
            <span className="span-1">MySQL —</span>{" "}
            <span className="span-2">Structured Data under Constant Load</span>
          </h2>
          <p>
            MySQL is a good option where applications handle structured data and
            predictable traffic. We use it when we require our systems to be
            able to cope with high volumes of transactions without becoming
            unstable.
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> Manages relational data with high
              levels of consistency.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Supports replication & clustering.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Performs well for transaction work
              loads.
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              A reservation platform is dependent on MySQL to process concurrent
              bookings keeping the availability updated.
            </p>
          </div>
        </div>
        {/* SQL Server*/}
        <div className="db-section">
          <h2>
            <span className="span-1">SQL Server —</span>{" "}
            <span className="span-2">
              Designed for Regulated And High Risk Environmentst
            </span>
          </h2>
          <p>
            SQL Server is important in the context that data sensitivity and
            governance is non negotiable. We use it in systems where audit,
            security and enterprise controls are mandatory.
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" />
              Advanced security and Role based access.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Native Integration with .NET and
              Azure.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Reliable when dealing with large
              and sensitive data sets.
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              A healthcare management system stores records of patients in SQL
              Server to comply with stringent standards of regulations and
              security.
            </p>
          </div>
        </div>
        {/* MongoDB*/}
        <div className="db-section">
          <h2>
            <span className="span-1">MongoDB —</span>{" "}
            <span className="span-2">
              When Data Models Change Faster Than Plans
            </span>
          </h2>
          <p>
            MongoDB is optimum when data structures are expected to change over
            time. We use it when the rigid schemas will slow down development,
            or will entail too much risk of migration.
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> Stores data in the flexible
              document formats.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Great scalable for content driven
              platforms.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Eliminates schema related
              bottlenecks.
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              A social platform is using MongoDB to store posts and interactions
              that have a very wide structure and a wide range of volume.
            </p>
          </div>
        </div>
        {/* PostgreSQL*/}
        <div className="db-section">
          <h2>
            <span className="span-1">PostgreSQL —</span>{" "}
            <span className="span-2">Precision Where Accuracy Cannot Slip</span>
          </h2>
          <p>
            PostgreSQL is used when data integrity and complex querying are very
            important. We rely on it for systems where being right is more
            important than being convenient.
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> Sophisticated Indexing & Query
              Optimisation.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Strong transactional guarantees.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Supports complex analytical
              workloads.
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              A financial reporting system includes the use of PostgreSQL to
              produce accurate and audit ready transaction reports.
            </p>
          </div>
        </div>
        {/* Redis*/}
        <div className="db-section">
          <h2>
            <span className="span-1">Redis —</span>{" "}
            <span className="span-2">Speed When Systems Cannot Wait</span>
          </h2>
          <p>
            Redis is introduced when the systems begin to slow down under load.
            We use it to process fast moving data and take the pressure off the
            primary databases.
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> Caches were used frequently to
              access data.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Handles sessions and counters
              effectively.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Allows for real time messaging
              patterns.
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              An online gaming platform uses Redis to instantly update
              leaderboards without any impact on core database performance.
            </p>
          </div>
        </div>
      </div>
      {/* Combined Databases Section */}
      <div className="db-combine-section">
        <div className="db-combine-flex">
          {/* Left Image */}
          <div className="db-combine-left">
            <img
              src={bannerImg}
              alt="Database Illustration"
              className="db-combine-img img-fluid"
            />
          </div>

          {/* Right Text */}
          <div className="db-combine-right">
            <h3 className="db-combine-title">
              How Our Developers Combine Databases In Real Systems
            </h3>
            <p className="db-combine-text">
              Most real applications cannot afford to rely on a single database
              without tradeoffs. Different types of data act differently and the
              effort to squeeze everything into one model tends to cause either
              performance or maintenance issues down the road. We design
              database setups based on the way data is used not the way it
              appears on diagrams.
              <br />
              Common combinations that we build include:
            </p>

            <ul className="db-combine-list">
              <li>
                <img src={arrowIcon2} alt="" />
                MySQL or PostgreSQL for primary business data, combined with
                Redis for caching (so that frequently read data is always fast,
                without overstressing the primary database)
              </li>
              <li>
                <img src={arrowIcon2} alt="" />
                MongoDB for flexible or evolving data, and SQL Server for
                transaction records, keeping the experimentation apart from the
                critical operations.
              </li>
              <li>
                <img src={arrowIcon2} alt="" />
                SQLite within mobile apps for offline work with a sync to a
                database in the cloud when connectivity is restored so that
                users are never blocked.
              </li>
            </ul>

            <p className="db-combine-text">
              By distributing the load onto multiple databases, systems remain
              responsive under load, flexible as requirements evolve, and
              reliable where accuracy is most important.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DbMain;
